var exports = {
  "kL": "GuildIcon.module__container___MmJOdW",
  "qJ": "GuildIcon.module__containerNoIcon___MmJOdW",
  "yC": "GuildIcon.module__initials___MmJOdW",
};

module.exports = exports;
